export let email_regex:any = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export let number_regex = /^[0-9]*$/;
export let Name:any = /^[a-zA-Z]*$/;
export let Name_space:any = /^[a-zA-Z ]*$/;
const frechExp = '^[a-zàâçéèêëîïôûùüÿñæœ .-]*$';
const germanExp = '^[a-zA-ZäöüßÄÖÜẞ .-]+$';
export let Name_1:any =  /^[^*|\":<>[\]{}`\\()';#%!@&$]+$/; // new RegExp('(' + frechExp + ')|(' + germanExp + ')');
export let Email:any = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export let SSN = '000 00 0000'
